import {
	LoyaltyDetailsSegment,
	SalesBreakDownResponse,
	SalesEvolutionResponse,
} from "./interfaces"
import { isEmptyObject } from "helpers/objects"
import {
	EMPTY_SALES_EVOLUTION_SIZE,
	EMPTY_LOYALTY_DETAILS_SIZE,
} from "components/CustomerBehavior/LoyaltyPerformance/constants"
import { FiltersType } from "components/Shared/GlobalFilter/context/interfaces"
import { FilterTypes } from "components/Shared/GlobalFilter/types"
import {
	LOCATION_GROUP_FILTER,
	PRODUCT_GROUP_FILTER,
} from "components/Shared/GlobalFilter/constants"
import { hasValidFilters } from "components/Shared/utils/utils"

export const EMPTY_STRING = ""

export const isChartsTablesFulfilled = (
	salesEvolutionData: SalesEvolutionResponse[],
	loyaltyDetailsResponse: LoyaltyDetailsSegment[],
	salesBreakDownResponse: SalesBreakDownResponse
): boolean => {
	return (
		salesEvolutionData.length !== EMPTY_SALES_EVOLUTION_SIZE &&
		loyaltyDetailsResponse.length >= EMPTY_LOYALTY_DETAILS_SIZE &&
		!isEmptyObject(salesBreakDownResponse)
	)
}

export const isMonthly = (value: string) => value.match(/[S]\w+/)

export const canRetrieveResults = (
	isSupplier: boolean,
	filters: FiltersType
): boolean => {
	return isSupplier || (!isSupplier && filters.vendors.length !== 0)
}

export const filtersToShow: Array<FilterTypes> = [
	LOCATION_GROUP_FILTER,
	PRODUCT_GROUP_FILTER,
]

export const validateFiltersForLoyalty = (filters: any) => {
	return hasValidFilters(filters, ["vendors", "period"])
}
